import React from 'react';

export const Stack = (props) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.2565 11.1904C11.6748 10.9366 12.2089 10.9366 12.6272 11.1904L19.5721 15.4049C20.39 15.9013 20.355 17.0526 19.5084 17.5027L12.5634 21.1955C12.177 21.401 11.7067 21.401 11.3202 21.1955L4.37531 17.5027C3.52868 17.0526 3.4937 15.9013 4.31158 15.4049L11.2565 11.1904Z"
      fill="white"
      stroke="black"
      strokeWidth="1.5"
    />
    <path
      d="M11.3137 7.16651C11.732 6.91269 12.2661 6.91269 12.6844 7.16651L19.6293 11.381C20.4472 11.8773 20.4122 13.0286 19.5656 13.4788L12.6207 17.1715C12.2342 17.377 11.7639 17.377 11.3774 17.1715L4.43252 13.4788C3.58589 13.0286 3.55091 11.8773 4.36878 11.381L11.3137 7.16651Z"
      fill="white"
      stroke="black"
      strokeWidth="1.5"
    />
    <path
      d="M11.3728 3.14257C11.7911 2.88875 12.3252 2.88875 12.7435 3.14257L19.6884 7.35707C20.5063 7.8534 20.4713 9.0047 19.6247 9.45487L12.6798 13.1476C12.2933 13.3531 11.823 13.3531 11.4365 13.1476L4.49162 9.45487C3.64499 9.0047 3.61001 7.8534 4.42789 7.35707L11.3728 3.14257Z"
      fill="white"
      stroke="black"
      strokeWidth="1.5"
    />
  </svg>
);
